<template>
	<footer class="small-12 columns siteFooter">
		<section class="small-12 footerTop"></section>
		<section class="small-12 footerBottom">
			<ul class="small-12 flex">
				<li class="small-4 columns">
					<p class="small-12 flex">
						&copy; {{ date }} Nestd. All rights reserved.
					</p>
				</li>
				<li class="small-4 columns">
					<p class="small-12 flex justify-center vertical-align">
						Made with 
						<i class="material-icons">favorite_border</i> 
						remotely.
					</p>
				</li>
				<li class="small-4 columns">
					<p class="small-12 flex justify-right">
						<a>Terms</a>
						<span>|</span>
						<a>Privacy</a>
					</p>
				</li>
			</ul>
		</section>
	</footer>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SiteFooter',

		/*
		**  Set up the data
		*/

		data: () => ({

			date: (new Date()).getFullYear()

		}),

	}

</script>